<template>
  <div id="result_wrapper">
    <el-card shadow="never" class="content_box">
      <el-row>
        <el-col :span="24">
          <div class="padding_wrap" v-if="!loading">
            <div class="topBlock">
              <div>
                <StatusIcon :customIcon="require('@/assets/images/payment/common/processing.png')" />
              </div>
              <div class="title">
                {{ operateAmount | formatNumber(formatDecimalNum) }} {{ currency | currencyConvert }}
              </div>
              <div class="time">{{ time }}</div>
              <div class="desc">
                <div v-if="resultChannelType === 'broker_to_broker_payment'">
                  {{ $t('deposit.default.reminderFundAppear') }}
                </div>
                <div v-if="successTextChannel.includes(resultChannelType)">
                  {{ $t('deposit.default.successMsg') }}
                </div>
                <div v-if="resultChannelType === 'bpay_payment'">
                  <p v-if="!hasFileList">
                    <i18n path="deposit.bPay.form.reminderNotUploaded" tag="div">
                      <template v-slot:mailTo>
                        <a :href="'mailto:' + GLOBAL_CONTACT_EMAIL">{{ GLOBAL_CONTACT_EMAIL }}</a>
                      </template>
                    </i18n>
                  </p>
                  <p class="last" v-if="!hasFileList">{{ $t('deposit.bPay.form.reminderProc') }}</p>
                  <p v-if="hasFileList">{{ $t('deposit.default.reminderFundAppear') }}</p>
                </div>
              </div>
            </div>
            <div class="detailBlock">
              <el-row type="flex">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.payToAccount') }}</el-col>
                <el-col :span="12" class="detail_content">{{ accountNumber }}</el-col>
              </el-row>
              <el-row v-if="regulatorIncluded" type="flex">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.depositAmount') }}</el-col>
                <el-col :span="12" class="detail_content"
                  >{{ depositAmount | formatNumber(formatDecimalNum) }} {{ currency | currencyConvert }}</el-col
                >
              </el-row>
              <el-row v-if="regulatorIncluded" type="flex">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.depositRebate') }}</el-col>

                <el-col v-if="depositRebate" :span="12" class="detail_content"
                  >{{ depositRebate | formatNumber(formatDecimalNum) }} {{ currency | currencyConvert }}</el-col
                >
                <el-col :span="12" class="detail_content" v-else>--</el-col>
              </el-row>
              <el-row type="flex">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.netDepositAmount') }}</el-col>
                <el-col :span="12" class="detail_content"
                  >{{ netDepositAmount | formatNumber(formatDecimalNum) }} {{ currency | currencyConvert }}</el-col
                >
              </el-row>
              <el-row v-if="regulatorIncluded" type="flex">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.voucherApplied') }}</el-col>
                <el-col :span="12" class="detail_content" v-if="voucherApplied">{{ voucherApplied }}</el-col>
                <el-col :span="12" class="detail_content" v-else>--</el-col>
              </el-row>
              <el-row type="flex" v-if="exchangeRate">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.exchangeRate') }}</el-col>
                <el-col :span="12" class="detail_content"
                  >1 {{ currency | currencyConvert }}≈{{ exchangeRate | formatNumber(2) }}
                  {{ orderCurrency | currencyConvert }}</el-col
                >
              </el-row>
              <el-row type="flex">
                <el-col :span="12" class="detail_label">{{ $t('thirdPartyDeposit.detail.payWith') }}</el-col>
                <el-col :span="12" class="detail_content">{{ paymentChannelName }}</el-col>
              </el-row>
            </div>
            <div class="btn-wrapper">
              <el-button type="primary" @click="backHome" data-testid="back_home_button"
                >{{ $t('thirdPartyDeposit.detail.bkHome') }} {{ `(${backHomeCountDown}s)` }}</el-button
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { apiThirdPartyDepositResult } from '@/resource';
import StatusIcon from '@/components/StatusIcon.vue';
import { SVG } from '@/constants/regulator';
import sensorsHandler from '@/util/sensorsdata/handler';
import { getDepositStatusByCode } from '@/constants/depositStatusEnum';

export default {
  name: 'NonCPSOfflineDepositResult',
  props: {
    resultChannelType: {
      type: String,
      default: null
    },
    orderNumber: {
      type: String,
      default: null
    },
    hasFileList: {
      type: Boolean,
      default: false
    }
  },
  components: { StatusIcon },
  data() {
    return {
      loading: true,
      operateAmount: 0,
      currency: '',
      orderCurrency: '',
      time: '',
      accountNumber: null,
      depositAmount: null,
      depositRebate: null,
      netDepositAmount: null,
      voucherApplied: null,
      exchangeRate: null,
      master: null, //大類
      channel: null, //小類
      payWith: '',
      isCrypto: false,
      backHomeCountDown: 8,
      backHomeCountDownId: null,
      successTextChannel: [
        'international_bank_payment',
        'international_bank_payment_equals',
        'mongolia_p2p',
        'payid',
        'euro-sepa'
      ]
    };
  },
  computed: {
    formatDecimalNum() {
      return this.isCrypto ? 4 : 2;
    },
    regulatorIncluded() {
      return this.regulator === SVG;
    },
    paymentChannelName() {
      let key1 = `channel.deposit.generalsetting.transactionhistorysubcategory.${this.master}_${this.channel}`;
      let key2 = `channel.deposit.generalsetting.transactionhistorycategory.${this.master}_${this.channel}`;
      if (this.$te(key1)) {
        return this.$t(key1);
      } else if (this.$te(key2)) {
        return this.$t(key2);
      } else {
        return '--';
      }
    }
  },
  methods: {
    getResult(paymentType, orderNumber) {
      apiThirdPartyDepositResult(paymentType, { orderNumber })
        .then(result => {
          const {
            status,
            mt4Account,
            currency,
            orderCurrency,
            operateAmount,
            depositAmount,
            rebateAmount,
            netDepositAmount,
            voucherApplied,
            rate,
            createdTime,
            paymentChannel,
            master,
            channel,
            isCrypto
          } = result.data.data;
          this.operateAmount = operateAmount;
          this.currency = currency;
          this.accountNumber = mt4Account;
          this.depositAmount = depositAmount;
          this.depositRebate = rebateAmount;
          this.netDepositAmount = netDepositAmount;
          this.voucherApplied = voucherApplied;
          this.exchangeRate = rate;
          this.orderCurrency = orderCurrency;
          this.time = createdTime;
          this.payWith = paymentChannel;
          this.master = master;
          this.channel = channel;
          this.isCrypto = isCrypto;
          this.loading = false;
          this.$nextTick(() => {
            this.backHomeCountDowning();
          });
          sensorsHandler('DEPOSIT_RESULTPAGE_VIEW', {
            account_info: this.accountNumber,
            order_id: this.orderNumber,
            order_status: getDepositStatusByCode(status).description,
            is_success: status == 5 ? 1 : 0,
            deposit_method_number: this.master,
            payment_method_number: this.channel
          });
        })
        .catch(err => {
          //TODO:
          this.loading = false;
        });
    },

    backHomeCountDowning() {
      this.backHomeCountDownId = setInterval(() => {
        this.backHomeCountDown--;
      }, 1000);
    },
    backHome() {
      sensorsHandler('DEPOSIT_BACKTOHOMEPAGE_CLICK', {
        account_info: this.accountNumber,
        deposit_method_number: this.master,
        payment_method_number: this.channel
      });
      this.$router.push('/home');
    }
  },
  mounted() {
    this.loading = true;
    if (this.orderNumber && this.resultChannelType) {
      this.getResult(this.resultChannelType, this.orderNumber);
    }
  },
  watch: {
    backHomeCountDown(value) {
      if (value === 0) {
        clearInterval(this.backHomeCountDownId);
        this.backHome();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#result_wrapper {
  padding-top: 60px;
  @include screen-tablet {
    padding-top: 20px;
  }
  .padding_wrap {
    width: 60%;
    margin: 0 auto;
    max-width: 460px;
    @media (max-width: 767px) {
      width: 100%;
      max-width: unset;
    }
  }
  .topBlock {
    margin-bottom: 20px;
    text-align: center;
    color: $PCS-main-text;
    .title {
      font-size: 26px;
      font-weight: 600;
      margin-top: 16px;
    }
    .time {
      padding: 8px 0;
      font-size: 12px;
    }
  }
  .detailBlock {
    border-top: 1px solid rgba($PCS-main-text, 0.12);
    border-bottom: 1px solid rgba($PCS-main-text, 0.12);
    padding: 16px 0 0 0;
    .el-row {
      padding-bottom: 16px;
    }
    .detail_label {
      @include rtl-sass-value(text-align, left, right);
      color: rgba($PCS-main-text, 0.65);
    }
    .detail_content {
      text-align: right;
      color: $PCS-main-text;
    }
  }
  .btn-wrapper {
    margin-top: 35px;
    .el-button {
      width: 100%;
      border-radius: 100px;
      height: 48px;
      &.custom_btn {
        color: rgba($PCS-main-text, 0.45);
        border-color: rgba($PCS-main-text, 0.45);
        &:hover {
          color: rgba($PCS-main-text, 0.6);
          border-color: rgba($PCS-main-text, 0.6);
        }
      }
    }
  }
}
</style>
